import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import FollowUpsFormModel from "../../models/follow-ups-form";

export default class FollowUpsFormRepository extends BaseRepository {
  static modelClass = FollowUpsFormModel;
  modelName = "follow-ups-form";

  async query({ actionItemId, formId, urlPath = null, params = null }) {
    let defaultURL = urlPath ?? "actionable_items/" + actionItemId + "/forms/" + formId;

    if (params && Object.keys(params).length > 0) {
      const queryString = qs.stringify(params);
      defaultURL += `?${queryString}`;
    }

    if ((actionItemId && formId) || urlPath) {
      return await super.query({
        urlPath: defaultURL,
      });
    }
  }
}
